import { createContext, useContext } from 'react';

import type { CellEditingStore } from './create-cell-editing-store';

const CellEditingContext = createContext<CellEditingStore | null>(null);

export const CellEditingProvider = CellEditingContext.Provider;

export function useCellEditingContext() {
  const context = useContext(CellEditingContext);

  if (!context) {
    throw new Error('useCellEditingContext must be used within a CellEditingProvider.');
  }

  return context;
}
